module.exports = __webpack_public_path__ + "account/assets/ok.a3395e26.svg";